import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/gold-logo-transparent.png'


const _hoisted_1 = { class: "bg-[#f9fafb] mt-10" }
const _hoisted_2 = { class: "w-full mx-auto p-4 pt-10 md:pt-4 md:py-8" }
const _hoisted_3 = { class: "flex flex-col items-center md:flex-row md:justify-between" }
const _hoisted_4 = { class: "flex flex-col gap-3 md:gap-0 md:flex-row flex-wrap items-center mb-6 text-sm font-medium text-gray-500" }
const _hoisted_5 = ["href"]


export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const navigation = [
  { name: 'Services', href: '/#services' },
  { name: 'How it works', href: '/#howitworks' },
  { name: 'Partners', href: '/#partners' },
  { name: 'Reviews', href: '/#reviews' },
  { name: 'Key features', href: '/#features' },
  { name: 'Blog', href: '/blog' },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("a", {
          href: "https://talabapp.co.uk",
          class: "flex items-center mb-10 sm:mb-0"
        }, [
          _createElementVNode("img", {
            src: _imports_0,
            class: "h-8",
            alt: "Flowbite Logo"
          })
        ], -1)),
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
            return _createElementVNode("li", {
              key: item.name
            }, [
              _createElementVNode("a", {
                href: item.href,
                class: "hover:underline me-0 md:me-6 text-center md:text-left"
              }, _toDisplayString(item.name), 9, _hoisted_5)
            ])
          }), 64)),
          _cache[0] || (_cache[0] = _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "/privacy-policy",
              class: "hover:underline me-0 md:me-6"
            }, "Privacy Policy")
          ], -1))
        ])
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "my-6 border-gray-200 sm:mx-auto lg:my-8" }, null, -1)),
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "block text-sm text-gray-500 text-center" }, [
        _createTextVNode("© 2025 "),
        _createElementVNode("a", {
          href: "https://talabapp.co.uk",
          class: "hover:underline"
        }, "TALAB"),
        _createTextVNode("™. All Rights Reserved.")
      ], -1))
    ])
  ]))
}
}

})